import type { ComponentPropsWithRef, ReactNode } from 'react';
import { forwardRef } from 'react';

import clsx from 'clsx';

const fontStyle = {
    default: 'text-xs text-icoGray-500 dark:text-icoDarkMode-wolf font-GSemiBold mb-2',
    scheduler: 'text-base font-GBold mb-3',
    radio: 'text-sm text-icoBlack dark:text-icoDarkMode-wolf font-GSemiBold',
    checkbox: 'text-sm text-icoBlack dark:text-icoDarkMode-wolf font-GSemiBold',
    checkboxList: 'text-xs text-icoBlack dark:text-white font-GMedium',
    checkboxListDisabled: 'text-xs text-icoGray-400 dark:text-white/50 font-GMedium',
    legalCheckbox: 'text-sm text-icoGray-500 dark:text-icoDarkMode-wolf font-GMedium',
    input: 'text-xs text-icoBlack dark:text-white mb-2',
    section: 'text-base text-icoBlack dark:text-white font-GSemiBold mb-4'
};

type LabelProps = ComponentPropsWithRef<'label'> & {
    className?: string;
    children?: ReactNode;
    fontType?: keyof typeof fontStyle;
    required?: boolean;
};

const Label = forwardRef<HTMLLabelElement, LabelProps>(
    ({ children, className = '', fontType = 'default', required = false, ...restProps }, ref) => {
        return (
            <label
                ref={ref}
                className={clsx('block w-full', fontStyle[fontType] ?? '', className)}
                {...restProps}>
                {children}
                {required && <span className="text-icoBlue">*</span>}
            </label>
        );
    }
);

Label.displayName = 'Label';

export default Label;
